module.exports = __webpack_public_path__ + "img/slogan.a7829cb9.png";